import ResponseHandlerCallToAction from '@alme/ui-web/modules/message-renderer-call-to-action/src/response-handler-call-to-action'
import { DefaultSettings, settings } from '@alme/ui-web/settings/settings-util'

export default class CustomResponseHandlerCallToAction extends ResponseHandlerCallToAction{

    constructor(passedSettings: DefaultSettings = settings)
    {
        super(passedSettings)
    }
}


// WEBPACK FOOTER //
// ./modules/custom-message-renderer-call-to-action/response-handler-call-to-action.ts